const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Switch+Shipping+Country+API


function switchShippingCountry(countryCode) {
    let url = '/api/users/profile/shippingCountry';
    return ufeApi.makeRequest(url, {
        method: 'PUT',
        body: JSON.stringify({ countryCode })
    }).then(data => data.errorCode ? Promise.reject(data) : data.countries);
}


module.exports = switchShippingCountry;
